import { render } from "./TheDealerBar.vue?vue&type=template&id=dcbeb928&scoped=true"
import script from "./TheDealerBar.vue?vue&type=script&lang=js"
export * from "./TheDealerBar.vue?vue&type=script&lang=js"

import "./TheDealerBar.vue?vue&type=style&index=0&id=dcbeb928&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-dcbeb928"

export default script